import type {TKeySessionType} from '@DrmController/Types/TKeySessionType';
import {KeySessionStatus} from '@State/Stores/Metrics/Constants/KeySessionStatus';

class DrmSession {
    public status: KeySessionStatus = KeySessionStatus.INACTIVE;
    public type: TKeySessionType = 'NONE';
}

export {DrmSession};
